module.exports = (__webpack_require__(3))(516);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/widgets/PluginConfigBreadcrumbWidget.js from dll-reference girder_lib
// module id = 41
// module chunks = 0